import { Button, Spin, Table } from "antd";

import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { showNotificationWithIcon } from "../../utils/helpers/helpers";
import { getMany } from "../../utils/http/dataProvider";
import { getUserInfo } from "../../utils/redux/reducers/User";
import "./ProductCategorySelector.scss";
import { useState } from "react";
import { getMerchantSettings } from "../../utils/redux/reducers/Merchant";

const i18n = Locale.getInstance();

const ProductCategorySelector = ({ setSelectedLink, selectedLink }) => {
  const user = useSelector((state) => getUserInfo(state));
  const settings = useSelector((state) => getMerchantSettings(state));
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data, error, isLoading } = useQuery(
    ["product-categories", user.token, page, perPage],
    () =>
      getMany("categories", {
        token: user.token,
        pagination: {
          perPage,
          page,
        },
      })
  );

  if (error) {
    console.log(
      "🚀 ~ file: ProductCategorySelector.jsx ~ line 38 ~ ProductCategorySelector ~ error",
      error
    );
    showNotificationWithIcon(error.data.message);
  }

  const columns = [
    {
      title: i18n.t("product.cats.name"),
      render: (item) => {
        return <span>{i18n.getPropNameByLocale(item, "name")}</span>;
      },
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 200,
    },
    {
      title: i18n.t("product.cats.actions"),
      width: 100,
      render: (item) => {
        return (
          <>
            <Button
              type={item.id === selectedLink.key ? "primary" : "default"}
              onClick={() => {
                const tabIndex = 1;
                if(settings.enable_course_on_homepage){
                  tabIndex = 2;
                }
                setSelectedLink({
                  key: item.id,
                  ug_name: `مەھسۇلات تۈرى~${item.ug_name}`,
                  zh_name: `产品分类~${item.zh_name}`,
                  url: `/pages/main-page/index?tabIndex=${tabIndex}&catId=${item.id}`,
                });
              }}
              size="small"
            >
              {item.id === selectedLink.key
                ? i18n.t("link.selected")
                : i18n.t("link.select")}
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Spin spinning={isLoading}>
        <div className="product-categories">
          <Table
            className="list"
            rowKey="id"
            columns={columns}
            dataSource={data?.data}
            scroll={{
              y: 320,
            }}
            pagination={{
              current: page,
              total: data?.total,
              pageSize: perPage,
              onChange: (pagination) => {
                setPage(pagination);
              },
            }}
            />
        </div>
      </Spin>
    </>
  );
};

export default ProductCategorySelector;
